// ---------------------------------------------------------------------------
// Theme
// ---------------------------------------------------------------------------
export interface Theme {
  bg: string;
  surface: string;
  surfaceHover: string;
  border: string;
  borderFocus: string;
  text: string;
  textMuted: string;
  accent: string;
  accentHover: string;
  danger: string;
  dangerHover: string;
  success: string;
  warning: string;
  codeBg: string;
}

export const theme: Theme = {
  bg: '#0f1117',
  surface: '#1a1d27',
  surfaceHover: '#222633',
  border: '#2a2e3d',
  borderFocus: '#4f8ff7',
  text: '#e4e4e7',
  textMuted: '#8b8fa3',
  accent: '#4f8ff7',
  accentHover: '#3a7be0',
  danger: '#ef4444',
  dangerHover: '#dc2626',
  success: '#22c55e',
  warning: '#f59e0b',
  codeBg: '#141620',
};

export const globalStyles = `
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    background: ${theme.bg};
    color: ${theme.text};
    line-height: 1.5;
  }
  ::-webkit-scrollbar { width: 8px; height: 8px; }
  ::-webkit-scrollbar-track { background: ${theme.bg}; }
  ::-webkit-scrollbar-thumb { background: ${theme.border}; border-radius: 4px; }
  ::-webkit-scrollbar-thumb:hover { background: ${theme.textMuted}; }
  ::selection { background: ${theme.accent}33; }
  @keyframes spin { to { transform: rotate(360deg); } }
`;
